var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "deliver-group-list" }, [_vm._l(_vm.deliverGroupList, function (deliverGroup, groupIndex) {
    return _c('el-card', { key: groupIndex, staticClass: "box-card deliver-group-list", attrs: { "shadow": "never" } }, [_c('div', { staticClass: "box-card-header", attrs: { "slot": "header" }, slot: "header" }, [_c('span', [_vm._v("适用流量：" + _vm._s(_vm._f("parseNonInteractiveChannel")(deliverGroup[0].channel)))]), _vm._v(" "), _c('div', [_c('el-button', { attrs: { "type": "text", "size": "medium" }, on: { "click": function click($event) {
          return _vm.openDialog(groupIndex);
        } } }, [_vm._v("批量上传附件")]), _vm._v(" "), _c('el-button', { attrs: { "icon": "el-icon-plus", "type": "text", "size": "medium" }, on: { "click": function click($event) {
          return _vm.addDeliver({ groupIndex: groupIndex });
        } } }, [_vm._v("Add")])], 1)]), _vm._v(" "), _vm._l(deliverGroup, function (deliver, index) {
      return _c('el-card', { key: deliver._id, staticClass: "box-card deliver-list", attrs: { "shadow": "never" } }, [_c('div', { staticClass: "deliver-item" }, [_c('deliver', { ref: "deliver", refInFor: true, attrs: { "deliver": deliver, "copy-tag": _vm.copyDeliverTag, "copy-scene": _vm.copySceneNum, "schemeValue": _vm.schemeValue }, on: { "copy-deliverTag": function copyDeliverTag(deliver) {
            _vm.handleCopyDeliverTag(deliver);
          }, "update-deliver": function updateDeliver(deliver) {
            _vm.handleUpdateDeliver({
              deliverIndex: index,
              groupIndex: groupIndex,
              deliver: deliver
            });
          } } }), _vm._v(" "), index > 0 ? _c('delete-button', { on: { "delete": function _delete($event) {
            return _vm.deleteDeliver({
              deliverIndex: index,
              groupIndex: groupIndex
            });
          } } }) : _vm._e()], 1)]);
    })], 2);
  }), _vm._v(" "), _c('el-dialog', _vm._b({ attrs: { "visible": _vm.dialog.visible }, on: { "update:visible": function updateVisible($event) {
        return _vm.$set(_vm.dialog, "visible", $event);
      } } }, 'el-dialog', _vm.dialog, false), [_c('batch-uploader', { attrs: { "set-file-list": _vm.setFileList, "file-list": _vm.fileList }, on: { "submit": _vm.handleSubmit } })], 1)], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };